import { render, staticRenderFns } from "./ModificarProfesional.vue?vue&type=template&id=270d6f54&scoped=true&"
import script from "./ModificarProfesional.vue?vue&type=script&lang=js&"
export * from "./ModificarProfesional.vue?vue&type=script&lang=js&"
import style0 from "./ModificarProfesional.vue?vue&type=style&index=0&id=270d6f54&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270d6f54",
  null
  
)

export default component.exports